import Footer from "../footer"
import NavBar from "../nav"
import { useState } from "react"

const News = () => {

	const [toggledTab, setToggledTab] = useState<string>('press-releases')

	const toggleTab = (type:string) => {
		setToggledTab(type)
	}

	const getTabClass = (type:string) => {

		const classes = ['nav-item'];
		if (toggledTab === type) {
			classes.push('active')
		}
		return classes.join(' ')
	}

  return <div className='news'>
    <NavBar />
    <div>
    <section className="clean-block pfa-content clearfix">
			<div className="divider sections">
				<h1>Latest News</h1>
				<div className="headline-divider sections"></div>
				<h2>Aviation. Safety. Compliance.</h2>
				<h3>Fly Compliant's Evolving Role</h3>
			</div>
		</section>
    <section className="clean-block clearfix">
			<div className="container content-container about-container">
				<div className="prose-header">A Force for Change.</div>
				<div className="prose">Fly Compliant prides itself on always being the subject matter expert when it comes to aviation safety and regulatory compliance and continues to inspire an industry with its invention, commitment to safety and devotion to an evolving sector. The following are some of the latest developments in our fulfillment of that mission.</div>	
			</div>
		</section>

		<section className="clean-block clearfix">
		    <ul className="nav nav-tabs justify-content-center" id="myTab" role="tablist">  
               
		        <li className={getTabClass('press-releases')}>
                    <div className="nav-link" id="press-releases-tab" data-toggle="tab" onClick={() => toggleTab('press-releases')} role="tab" aria-controls="press-releases" aria-selected="true">Press Releases</div>
                </li>
               
		        <li className={getTabClass('announcement')}>
                    <div className="nav-link" id="announcement-tab" data-toggle="tab" onClick={() => toggleTab('announcement')} role="tab" aria-controls="announcement" aria-selected="false">Announcements</div>
                </li>
               
		        <li className={getTabClass('industry-news')}>
                    <div className="nav-link" id="industry-news-tab" data-toggle="tab" onClick={() => toggleTab('industry-news')} role="tab" aria-controls="industry-news" aria-selected="false">Industry News</div>
                </li>
                <li className={getTabClass('white-paper')}>
                    <div className="nav-link" id="white-paper-tab'; ?>" data-toggle="tab" onClick={() => toggleTab('white-paper')} role="tab" aria-controls="white-paper" aria-selected="false">White Papers</div>
                </li>
            </ul>
            <div className="tab-content" id="myTabContent">         
                {toggledTab === 'press-releases' && <div className="tab-pane fade active show" id="press-releases" role="tabpanel" aria-labelledby="press-releases">                    
 			        <div className="container content-container square-container">               
     
                        <div className="grid-1 callout">
                            <div className="prose-header">New Collaboration with the US Private Aviation Association (USPAA) - August, 2023</div>
					        <div className="prose">Fly Compliant, LLC is announcing its collaboration with the US Private Aviation Association (USPAA). USPAA is a new organization dedicated to the interest of part 135 operators. Join us in Nashville September 7<sup>th</sup> and 8<sup>th</sup> as Fly Compliant and USPAA will be presenting their goals for the industry.</div>
					        <div className="learn-more-container"><a className="learn-more" href="/assets/pdf/press-releases/Press-Release_20230801_New-Collaboration-With-USPAA.pdf" target="_blank" rel="noreferrer">Download Press Release</a></div>
				
				        </div>
     
                        <div className="grid-2 callout">
                            <div className="prose-header">5th Annual Compliance Seminar - August, 2023</div>
					        <div className="prose">Fly Compliant, LLC is hosting its 5th annual compliance seminar on September 7<sup>th</sup> and 8<sup>th</sup> in Nashville. This year we have set a new industry standard, with a less is more approach by introducing "Explicit Procedures" in our manual system. We are removing the bloat and unnecessary content and then offering a back-to-basic approach to training. This approach enhances efficiency and increases safety.</div>
					        <div className="learn-more-container"><a className="learn-more" href="/assets/pdf/press-releases/Press-Release_20230801_Fly-Compliant-Compliance-Seminar.pdf" target="_blank" rel="noreferrer">Download Press Release</a></div>
				
				        </div>
                    </div>
                </div>}
                {toggledTab === 'announcement' && <div className="tab-pane fade" id="announcement" role="tabpanel" aria-labelledby="announcement">                    
 			        <div className="container content-container square-container">               
     
                        <div className="grid-1 callout">
                            <div className="prose-header">Aircrew Program Designees - May, 2022</div>
					        <div className="prose">Fly Compliant has developed the first part 135 Aircrew Designated Examiner Program which consists of an Aircraft Program Designee (ADE) and Aircrew Program Manager (APM).  An ADE allows operators to designate their own check pilots and conduct certification within a specifically-approved program. The FAA monitors the program with a designated APM, usually a FAA inspector other than the POI.</div>
				
				        </div>
     
                        <div className="grid-2 callout">
                            <div className="prose-header">Pilot Development Program - February, 2022</div>
					        <div className="prose">Fly Compliant has developed the standard to comply with AC 135-43 Pilot Development Program to obtain OpSpecs A062.  The PDP program allows a pilot employed by a part 135 air carrier and serving as an assigned second in command (SIC) in a multiengine airplane or single-engine, turbine-powered airplane to log SIC flight time during operations that do not require a second pilot.</div>
					        <div className="learn-more-container"><a className="learn-more" href="/manuals">Pilot Development Program</a></div>
				
				        </div>
     
                        <div className="grid-3 callout">
                            <div className="prose-header">Annual Compliance Seminar - August, 2022</div>
					        <div className="prose">Orlando, FL November 3rd and 4th Fly Compliant is hosting its annual compliance seminar and introducing the ACE Program pilot training concept. The ACE Program is a back to basic approach for pilots to be fully engaged and not reliant on technology.</div>
					        <div className="learn-more-container"><a className="learn-more" href="services/fly-compliant-academy">Seminar</a></div>
				
				        </div>
     
                        <div className="grid-4 callout">
                            <div className="prose-header">Hazardous Material Manual - September, 2021</div>
					        <div className="prose">The Fly Compliant, LLC hazardous material manual for Will and Will-Not-Carry programs has been selected as the manual of choice by the FAA to address the requirements of AC 121-40.</div>
					        <div className="learn-more-container"><a className="learn-more" href="manuals/hazardous-materials">Hazardous Material Manual</a></div>
				
				        </div>
     
                        <div className="grid-5 callout">
                            <div className="prose-header">Fly Compliant PSOC Approval - October, 2021</div>
					        <div className="prose">Fly Compliant has developed a standard process for assisting in the streamlining of the LOA process.</div>
					        <div className="learn-more-container"><a className="learn-more" href="https://www.faa.gov/about/office_org/headquarters_offices/avs/offices/afx/afs/afs400/afs410/part91_loa_process/" target="_blank" rel="noreferrer">PSOC Link</a></div>
				
				        </div>
     
                        <div className="grid-6 callout">
                            <div className="prose-header">A New Website - March, 2021</div>
					        <div className="prose">Fly Compliant, LLC launches a new website providing answers to regulatory questions. Over the years we have answered many regulatory questions. Now we have created a regulatory database to answer many of the common questions. Users can even submit their own regulatory question to our team of experts.</div>
					        <div className="learn-more-container"><a className="learn-more" href="/regulations">Frequently Asked Regulations (FARs)</a></div>
				
				        </div>
                    </div>
                </div>}
                {toggledTab === 'industry-news' && <div className="tab-pane fade" id="industry-news" role="tabpanel" aria-labelledby="industry-news">                    
 			        <div className="container content-container square-container">               
     
                        <div className="grid-1 callout">
                            <div className="prose-header">Fly Compliant Safety Standard - March, 2021</div>
					        <div className="prose">Fly Compliant, LLC releases the Fly Compliant, LLC Safety Standard detailing requirements to meet the highest operating requirements. Operators using our LevelFlight SMS will be provided an Automated Risk Assessment (ARA), as an objective measurement of operational risk distributed to all parties per flight.</div>
					        <div className="learn-more-container"><a className="learn-more" href="/safety/safety-standard">Learn More</a></div>
				
				        </div>
     
                        <div className="grid-2 callout">
                            <div className="prose-header">Threat Briefing - March, 2021</div>
					        <div className="prose">As part of our Automated Risk Assessment Fly Compliant, LLC has developed a Dynamic Threat Briefing based on actual conditions. Operators using the LevelFlight.com now provide pilots a standardized method of briefing for the pending flight with real-time data. This increases CRM for both pilots and ensures compliance with SOPs. The threat brief highlights flight conditions to emergency procedures increasing pilot awareness and safety.</div>
					        <div className="learn-more-container"><a className="learn-more" href="/contact-us">Contact Us</a></div>
				
				        </div>
     
                        <div className="grid-3 callout">
                            <div className="prose-header">Fly Compliant Safety Board - March, 2021</div>
					        <div className="prose">Fly Compliant, LLC announces assemblance of the Fly Compliant Safety Board. The safety board is comprised of industry professionals and business leaders. Safety Board mission is to assess operational risk and develop standards for all members using the LevelFlight Safety Management System (SMS). An outcome of this process will be a proactive Risk Profile with an evolving manual system with the latest risk assessment.</div>
					        <div className="learn-more-container"><a className="learn-more" href="/safety/safety-board">Learn More</a></div>
				
				        </div>
     
                        <div className="grid-4 callout">
                            <div className="prose-header">CRM for SMS - March, 2021</div>
					        <div className="prose">Fly Compliant, LLC has introduced Collective Resource Management for Safety Management System or CRM for SMS. The Fly Compliant, LLC safety board will review all participating LevelFlight user’s data and will focus on an acceptable operating standard. By focusing on procedures an outcome will be a group standard. The benefit is safer practices and highly efficient operations.</div>
					        <div className="learn-more-container"><a className="learn-more" href="/contact-us">Contact Us</a></div>
				
				        </div>
                    </div>
                </div>}
				{toggledTab === 'white-paper' && 
                <div className="tab-pane fade" id="white-paper" role="tabpanel" aria-labelledby="white-paper">
 			        <div className="container content-container square-container">  
                        <div className="grid-1 callout">
                            <div className="col-12 mb-3">
                                <div className="prose-header">The Evolution of SMS</div>
                                <div className="prose">Safety Management needs to be participated by all stakeholders and seen as an industry standard not just specific to any one company. Safety management for General Aviation industry has not been fully realized.</div>
                                <div className="learn-more-container"><a className="learn-more" href="/uploads/whitepapers/1/The-Evolution-of-SMS.pdf" target="_blank">Download Article</a></div>
                            </div>
                        </div>
            
                    </div>
                </div>}
            </div>
		</section>

    </div>
    <Footer />
  </div>
}

export default News